import React from "react";
import "./Video.css";

const Video = () => {
  const videos = [];

  for (let i = 1; i <= 3; i++) {
    videos.push(`${process.env.PUBLIC_URL}/images/v${i}.mp4`);
  }

  return (
    <div className="video-container">
      <h2 className="video-title">🎥 Video Gallery</h2>

      <div className="video-grid">
        {videos.map((src, index) => (
          <div className="video-card" key={index}>
            <video
              className="video-player"
              controls      // 👈 PLAY BUTTON
              preload="metadata"
            >
              <source src={src} type="video/mp4" />
              Video not supported
            </video>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Video;
